import * as React from 'react'
import Dashboard from '../../components/Dashboard'
import {connect} from 'react-redux'

class DashboardSection extends React.Component <Props, State>{
    render(){
        return(
            <Dashboard
            dashboardList={this.props.dashboardList}
            />
        )
    }
}

function bindAction (dispatch){
    return{
        dashboardList: () => {
            // console.log("dashboard index work")
            // dispatch(dashboardList())
        },
    }
}

const mapStateToProps = state =>({})

export default connect (
    mapStateToProps, bindAction
)(DashboardSection)